import React, { useEffect } from "react";
import { BackHandler, View, useWindowDimensions } from "react-native";
import { Theme, ThemeConsumer } from "@rneui/themed";
import { createMaterialTopTabNavigator } from "@react-navigation/material-top-tabs";
import moment from "moment";

//common components
import CommonHeader from "../../../shared/commonComponents/commonHeader";
//module
import { useAppNavigation, useAppRoute } from "../../../types/@react-navigation/navigation";
//pages
import AdminHistory from "./adminHistory";
import POSHistory from "./posHistory";

import { ZenBadge, ZenIcon, ZenText } from "zen-core-elements";

const CustomerHistory = () => {
    //Variable for Top tap navigation
    const TopTab = createMaterialTopTabNavigator()
    //variable which holds route params
    const { params } = useAppRoute("CustomerHistory")
    //Variable to store device width
    const { width } = useWindowDimensions()
    //Varible which is used for navigation
    const navigation = useAppNavigation()

    useEffect(() => {
        const backHandler = BackHandler.addEventListener('hardwareBackPress', () => {
            navigation.goBack()
            return true
        });
        return () => backHandler?.remove()
    }, [])
    return (
        <ThemeConsumer>
            {({ theme }: { theme: Theme }) => (
                <View style={theme?.customerHistoryStyle?.mainView}>
                    <CommonHeader headerName="Customer History" backIcon backIconOnpress={() => { navigation?.goBack() }} />
                    <View style={[theme?.customerHistoryStyle?.firstOuterView, { flex: 1 }]}>
                        <View style={[theme?.customerHistoryStyle?.detailsOuterView, { flexDirection: "row" }]}>
                            <View style={theme?.customerHistoryStyle?.detailsInnerView}>
                                <View style={[theme?.customerHistoryStyle?.profileView, { width: 40, height: 40 }]}>
                                    <ZenIcon name="person" type="material" size={24} color={theme?.light} />
                                </View>
                                <View style={{ rowGap: 5 }}>
                                    <ZenText content={params?.customerHistoryData?.user?.firstName + " " + params?.customerHistoryData?.user?.lastName} bold size={theme?.smallerFontSize} color={theme?.lightDark} />
                                    <ZenBadge
                                        badgeName={params?.customerHistoryData?.isWholesale && params?.customerHistoryData?.isApproved ? "WholeSale customer" : "Customer"}
                                        badgeColor='#ffedbd'
                                        badgeTextColor={theme.dark}
                                        badgeTextSize={"small"}
                                        badgeTextStyle={{ fontFamily: theme.bold }}
                                    />
                                </View>
                            </View>
                            <View style={{ marginRight: 10 }}>
                                <ZenText content="Created on " size={theme?.smallFontSize} color={theme?.grey} />
                                <ZenText content={moment(params?.customerHistoryData?.user?.createdAt).format('MMM DD, YYYY')} size={theme?.smallerFontSize} bold color={theme?.lightDark} />
                            </View>
                        </View>
                        <View style={{ flex: 1 }}>
                            <TopTab.Navigator
                                initialRouteName="Admin History"
                                screenOptions={{
                                    tabBarLabelStyle: { fontSize: theme.mediumFontSize, fontFamily: theme.bold, textTransform: 'capitalize' },
                                    tabBarIndicatorStyle: { backgroundColor: theme.primary },
                                    tabBarActiveTintColor: theme.primary,
                                    tabBarInactiveTintColor: theme.lightFontColor,
                                    tabBarAndroidRipple: { borderless: false },
                                }}
                                backBehavior="none"
                            >
                                <TopTab.Screen
                                    name="Admin History"
                                    options={{ tabBarLabel: 'Admin History', title: "Admin History" }}
                                    children={() => <AdminHistory customerId={params?.customerHistoryData.customerId} />}
                                />
                                <TopTab.Screen
                                    name="POS History"
                                    options={{ tabBarLabel: 'POS History', title: "POS History" }}
                                    children={() => <POSHistory customerId={params?.customerHistoryData.customerId} />}
                                />
                            </TopTab.Navigator>
                        </View>
                    </View>
                </View>
            )}
        </ThemeConsumer>
    )
}

export default React.memo(CustomerHistory)